import React, { Suspense } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "./routes";
import SeriesIndexv2 from '../scenes/Pages/publicresults/SeriesIndexv2';    
function RouterProvider() {
  const loaderStyle = {
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100dvh", // Full (dynamic) viewport height
  };
  return (
    <Routes>
      {routes.map((route, i) => {
        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Suspense
                fallback={
                  <div style={loaderStyle}>
                    <CircularProgress  />
                  </div>
                }
              >
                {route.component}
              </Suspense>
            }
          />
        );
      })}
      <Route path="/publicresults/SeriesIndex" element={<SeriesIndexv2 />} />
    </Routes>
  );
}

export default RouterProvider;
